<script lang="ts">
    export let class_list = [];
    export let prefix_icon = "";
    export let helper_text = "";
    export let helper_text_success = "";
    export let helper_text_wrong = "";
</script>

<div class="input-field {class_list.join(' ')}">
    {#if prefix_icon}<i class="material-icons prefix">{prefix_icon}</i>{/if}

    <slot/>

    {#if helper_text || helper_text_success || helper_text_wrong}
        <span
            class="helper-text"
            data-error={helper_text_wrong}
            data-success={helper_text_success}
        >{helper_text}</span>
    {/if}
</div>
